(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('.shopify-section.section-header');
    let header = section ? section.querySelector('header') : null;
    let headerHeight = header ? header.getBoundingClientRect().height : 0;
  document.documentElement.style.setProperty('--header-height', `${parseInt(headerHeight)}px`);
  console.log("Header height is " + headerHeight);
  });

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.isHeaderTransparent();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section.section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      if (this.isHeaderTransparent()) {
        this.header.classList.remove('section-header--transparent');
      }
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      if (this.isHeaderTransparent()) {
        this.header.classList.remove('section-header--transparent');
      }
    }

    reset() {
      if (this.isHeaderTransparent()) {
        this.header.classList.add('section-header--transparent');
      }
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }

    isHeaderTransparent() {
      let isHeaderTransparent = false;

      document.querySelectorAll('section').forEach(section => {
        const transparentSections = ['hero-slideshow-section', 'image-banner-section'];

        transparentSections.forEach(sectionClass => {
          const section = document.querySelector(`.${sectionClass}`);
          const sectionComponent = section?.querySelector('.hero-index-1');

          if (section && sectionComponent) {
            sectionComponent.classList.add('incl-transparent-header');
            const sectionHeader = document.querySelector('.section-header');
            sectionHeader?.classList.add('section-header--transparent');
            isHeaderTransparent = true;
          }
        });
      });

      return isHeaderTransparent;
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow-image-with-text"]) return;
  try {
    
  // <script src="https://cdn.shopify.com/s/files/1/0625/9313/8947/files/swiper-bundle.min.js?v=1690967110" defer="defer"></script>

  } catch(e) { console.error(e); }
})();
})();
